<template>
  <div class="container text-white">
    <div class="p-4 rounded shadow">
      <h1 class="text-primary fw-bold mb-3">
        <i class="fas fa-user-shield me-2"></i>{{ $t('privacy.title') }}
      </h1>
      <p class="mb-3">{{ $t('privacy.intro') }}</p>

      <h5 class="text-primary mt-4">
        <i class="fas fa-database me-2"></i>{{ $t('privacy.data_collection_title') }}
      </h5>
      <ul>
        <li>{{ $t('privacy.data_ip') }}</li>
        <li>{{ $t('privacy.data_contact') }}</li>
        <li>{{ $t('privacy.data_cookies') }}</li>
      </ul>

      <h5 class="text-primary mt-4">
        <i class="fas fa-question-circle me-2"></i>{{ $t('privacy.why_title') }}
      </h5>
      <p>{{ $t('privacy.why_reason') }}</p>

      <h5 class="text-primary mt-4">
        <i class="fas fa-user-lock me-2"></i>{{ $t('privacy.rights_title') }}
      </h5>
      <ul>
        <li>{{ $t('privacy.rights_access') }}</li>
        <li>{{ $t('privacy.rights_delete') }}</li>
        <li>{{ $t('privacy.rights_modify') }}</li>
      </ul>

      <h5 class="text-primary mt-4">
        <i class="fas fa-envelope me-2"></i>{{ $t('privacy.contact_title') }}
      </h5>
      <p>{{ $t('privacy.contact_text') }}</p>
    </div>
  </div>
</template>


<script setup>
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

useHead({
  title: t('privacy.title'),
  meta: [{ name: 'description', content: t('privacy.meta_description') }]
})
</script>

<style scoped>
.text-primary {
  color: #00ffcc !important;
}
</style>